import Swiper from 'swiper';
import Cookies from 'js-cookie'

var body = $(document.body);
var headmenu = $('.js-head-menu').first();
var headsearch = $('.js-head-search').first();
var headuser = $('.js-head-user').first();

var iconmenu = $('.headline__sandwich__icon')
var iconseach = $('.headline__search__icon')
var iconuser = $('.headline__user__icon')

function closeAll() {
    iconmenu.removeClass('headline__icon_close opacity50');
    iconseach.removeClass('headline__icon_close opacity50');
    iconuser.removeClass('headline__icon_close opacity50');

    headmenu.hide();
    headsearch.hide();
    headuser.hide();

    bodyFixed(false);
}


var headMenuOpen = function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (headmenu.is(":visible")) {
        closeAll()
    } else {
        closeAll()
        iconmenu.addClass('headline__icon_close')
        iconseach.addClass('opacity50');
        iconuser.addClass('opacity50');

        headmenu.show('fast');
        bodyFixed(true);
    }
};

body.on('click', '.js-sandwich', headMenuOpen);


var headSearchOpen = function (event) {
    event.preventDefault();
    event.stopPropagation();

    if (headsearch.is(":visible")) {
        closeAll()
    } else {
        closeAll()
        iconmenu.addClass('opacity50');
        iconseach.addClass('headline__icon_close');
        iconuser.addClass('opacity50');

        headsearch.show('fast');
        bodyFixed(true);
    }
};

body.on('click', '.js-search', headSearchOpen);


var headUserOpen = function (event) {
    if (headuser.is(":visible")) {
        closeAll()
    } else {
        closeAll()

        iconmenu.addClass('opacity50');
        iconseach.addClass('opacity50');
        iconuser.addClass('headline__icon_close');

        headuser.show('fast');
        bodyFixed(true);
    }
};

body.on('click', '.js-user', headUserOpen);


var pageLoad = function (event) {
    event.preventDefault();
    event.stopPropagation();

    var btn = $(this)
    var url = btn.attr('href');
    var wall = $('.js-wallpapers')

    btn.removeClass('js-page').on({
        click: function (e) {
            e.preventDefault()
        }
    }).addClass('disable')

    wall.after($("<div>").load(url + " .js-wallpapers", function () {
        btn.remove()
        window.history.pushState(url, 'title', url);

        var ads = $(this).find('.adsbygoogle')
        if (ads.length) {
            ads.each(function () {
                (adsbygoogle = window.adsbygoogle || []).push({});
            });
        }
    }))
}

body.on('click', '.js-page', pageLoad);


let allSwiperMenu = document.querySelectorAll('.js-swiper-select');
if (allSwiperMenu.length > 0) {
    for (let i = 0; i < allSwiperMenu.length; i++) {
        let item = allSwiperMenu[i]
        let swiperMenu = new Swiper(item, {slidesPerView: 'auto', loop: true})

        let selectSwiperMenuItem = $(item).find('.select')
        if (selectSwiperMenuItem && selectSwiperMenuItem.length) {
            swiperMenu.slideTo(selectSwiperMenuItem.index(), 1000)
        }
    }
}

var playPop = document.querySelector('.js-play_pop');
if (playPop !== null) {
    var isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
    if (isAndroid) {
        if (Cookies.get("android_show") == null) {
            $(this).delay(10000).queue(function () {
                $(playPop).show();
                bodyFixed(true);

                $(".js-play-con, .js-play_lin").on({
                    click: function () {
                        Cookies.set("android_show", 1, {expires: 7, path: '/'});

                        $(playPop).hide();
                        bodyFixed(false);
                    }
                });

                $(this).dequeue();
            });
        }
    }
}
